"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightningBoltAbilityHandler = exports.LightningBoltActorAbilityFactory = exports.LightningBoltAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class LightningBoltAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.LightningBolt;
        this.__typeName = "LightningBolt";
    }
}
exports.LightningBoltAbilityArgs = LightningBoltAbilityArgs;
let LightningBoltActorAbilityFactory = class LightningBoltActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("LightningBolt", "OneEnemies", 0);
    }
};
LightningBoltActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("LightningBolt")
], LightningBoltActorAbilityFactory);
exports.LightningBoltActorAbilityFactory = LightningBoltActorAbilityFactory;
let LightningBoltAbilityHandler = class LightningBoltAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            projectileType: "RedLightningBolt",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Nature", 50)
            ],
            onHitOrMiss: (sequence, { hit }) => sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet")
                : LocationSelector_1.ActorVfxLocationSelector.Miss(selectedEnemy), "LightningStrike"))
        });
    }
};
LightningBoltAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.LightningBolt)
], LightningBoltAbilityHandler);
exports.LightningBoltAbilityHandler = LightningBoltAbilityHandler;
